import { Reveal, SectionHeading, Overline } from "./Primitives";
import { COMMERCIAL_SERVICES } from "@/data/content";
import { Check, ArrowUpRight } from "lucide-react";

export const Commercial = () => {
  const scrollToQuote = () =>
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="commercial" className="relative bg-[#050505] py-20 md:py-28 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <SectionHeading
            overline="Commercial Cleaning"
            title={<>A cleaner workplace. A stronger <span className="gold-gradient italic">professional impression.</span></>}
            subtitle="Your business environment speaks volumes about your brand. Our professional commercial cleaning services help keep your workplace clean, organized, polished and ready for business—dependable solutions tailored to your facility, schedule and operational needs."
          />
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-12 lg:items-start">
          {/* Services */}
          <Reveal className="lg:col-span-7">
            <div className="grid gap-3 sm:grid-cols-2">
              {COMMERCIAL_SERVICES.map((s) => (
                <div key={s} className="flex items-center gap-3 border border-white/5 bg-[#121212] px-4 py-3.5 hover:border-gold/40 transition-colors duration-300">
                  <span className="w-6 h-6 flex items-center justify-center border border-gold/40 text-gold shrink-0">
                    <Check size={14} />
                  </span>
                  <span className="text-sm text-zinc-300">{s}</span>
                </div>
              ))}
            </div>
            <p className="mt-6 font-display italic text-gold text-lg">
              Create a workplace your employees appreciate and your clients remember.
            </p>
            <button
              data-testid="commercial-quote-btn"
              onClick={scrollToQuote}
              className="group mt-5 inline-flex items-center gap-2 bg-gold text-black font-semibold px-7 py-4 hover:bg-[#c5a059] transition-colors duration-300"
            >
              Request a Commercial Cleaning Estimate
              <ArrowUpRight size={17} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </Reveal>

          {/* Customized Quotes */}
          <Reveal className="lg:col-span-5" delay={0.1}>
            <div className="border border-gold/25 bg-gradient-to-br from-[#151208] to-[#0a0a0a] p-8 h-full flex flex-col">
              <Overline className="mb-2">Customized Quotes</Overline>
              <p className="font-display text-2xl text-white">Pricing designed around your property</p>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">
                Every property is unique, and your cleaning plan should be too. We take the time to understand
                the size, layout, condition, frequency and specific requirements of your space before providing
                a customized quote. No generic pricing. No one-size-fits-all estimates. For larger commercial
                spaces or more detailed requirements, we recommend a complimentary on-site walkthrough so we can
                assess accurately and provide the most precise estimate.
              </p>
              <div className="mt-6 flex flex-col gap-3">
                <button
                  data-testid="commercial-customquote-btn"
                  onClick={scrollToQuote}
                  className="bg-gold text-black font-semibold px-6 py-3.5 hover:bg-[#c5a059] transition-colors duration-300"
                >
                  Request Your Customized Quote
                </button>
                <button
                  data-testid="commercial-walkthrough-btn"
                  onClick={scrollToQuote}
                  className="border border-gold text-gold font-medium px-6 py-3.5 hover:bg-gold/10 transition-colors duration-300"
                >
                  Request a Free Walkthrough
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
